import React from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import {
  LayoutDashboard,
  Store,
  ShoppingCart,
  Package,
  CreditCard,
  CheckSquare,
  BarChart3,
  LogOut,
  Candy,
  Users,
  User
} from 'lucide-react';

const Layout = () => {
  const { user, logout } = useAuth();
  const location = useLocation();

  const menuItems = [
    { path: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
    { path: '/retailers', label: 'Retailers', icon: Store },
    { path: '/orders', label: 'Orders', icon: ShoppingCart },
    { path: '/products', label: 'Products', icon: Package },
    { path: '/payments', label: 'Payments', icon: CreditCard },
    { path: '/tasks', label: 'Tasks', icon: CheckSquare },
    { path: '/analytics', label: 'Analytics', icon: BarChart3 },
    ...(user?.role === 'Admin' ? [{ path: '/users', label: 'Users', icon: Users }] : []),
    { path: '/profile', label: 'Profile', icon: User },
  ];

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <aside style={{
        width: '250px',
        backgroundColor: '#2c3e50',
        color: 'white',
        padding: '20px'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          marginBottom: '30px',
          paddingBottom: '20px',
          borderBottom: '1px solid rgba(255,255,255,0.1)'
        }}>
          <Candy size={32} style={{ marginRight: '10px', color: '#FF69B4' }} />
          <div>
            <h2 style={{ fontSize: '18px', margin: 0 }}>Cotton Candy Station</h2>
            <p style={{ fontSize: '12px', opacity: 0.7, margin: 0 }}>Order Management</p>
          </div>
        </div>

        <nav>
          {menuItems.map(item => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '12px 15px',
                  marginBottom: '5px',
                  color: 'white',
                  textDecoration: 'none',
                  borderRadius: '5px',
                  backgroundColor: isActive ? 'rgba(255,105,180,0.3)' : 'transparent',
                  transition: 'background-color 0.3s'
                }}
                onMouseEnter={(e) => {
                  if (!isActive) e.target.style.backgroundColor = 'rgba(255,255,255,0.1)';
                }}
                onMouseLeave={(e) => {
                  if (!isActive) e.target.style.backgroundColor = 'transparent';
                }}
              >
                <Icon size={20} style={{ marginRight: '10px' }} />
                {item.label}
              </Link>
            );
          })}
        </nav>

        <div style={{
          position: 'absolute',
          bottom: '20px',
          left: '20px',
          right: '20px'
        }}>
          <div style={{
            padding: '10px',
            borderTop: '1px solid rgba(255,255,255,0.1)',
            paddingTop: '20px'
          }}>
            <div style={{ fontSize: '12px', marginBottom: '15px' }}>
              <div style={{ fontWeight: '500' }}>{user?.username}</div>
              <div style={{ opacity: 0.7, fontSize: '11px' }}>{user?.role || 'User'}</div>
            </div>
            <button
              onClick={logout}
              style={{
                display: 'flex',
                alignItems: 'center',
                background: 'none',
                border: 'none',
                color: 'white',
                cursor: 'pointer',
                fontSize: '14px',
                padding: '8px 12px',
                borderRadius: '5px',
                width: '100%',
                transition: 'background-color 0.3s'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.1)'}
              onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
            >
              <LogOut size={16} style={{ marginRight: '8px' }} />
              Logout
            </button>
          </div>
        </div>
      </aside>

      <main style={{ flex: 1, backgroundColor: '#f5f5f5' }}>
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;